import { render, staticRenderFns } from "./volunteer-recruit.vue?vue&type=template&id=56800c1c&scoped=true"
import script from "./volunteer-recruit.vue?vue&type=script&lang=js"
export * from "./volunteer-recruit.vue?vue&type=script&lang=js"
import style0 from "./volunteer-recruit.vue?vue&type=style&index=0&id=56800c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56800c1c",
  null
  
)

export default component.exports